import React, { useRef, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl';
import { Box, Container, Typography, Hidden } from '@material-ui/core'
import { Image, Transformation } from 'cloudinary-react'

import { MEDIUM_SIZE } from 'assets/CloudinaryURLHelper'
import PageWrapper from 'shared/wrappers/PageWrapper/PageWrapper'
import { useStyles } from './StartupsLandingPage_style'
import Button from 'components/Button/Button'
import HorizontalCardsSlider from 'shared/components/HorizontalCardsSlider/HorizontalCardsSlider'
import CompanyCard from 'cards/CompanyCard/CompanyCard'
import StartupsHelmet from 'helmets/StartupsHelmet'
import RouteMap from 'assets/RouteMap'

const TYPEFORM_SCHEDULER_LINK_NL = 'https://studentbe-c482a9.pipedrive.com/scheduler/YoLQaLUj/meeting'
const TYPEFORM_SCHEDULER_LINK_FR = 'https://studentbe-c482a9.pipedrive.com/scheduler/lW8Oa8cW/meeting'

const StartupsLandingPage = (props) => {
    const classes = useStyles()
    const { startups } = props
    const iframeRef = useRef(null)
    const locale = RouteMap.GetLocaleFromUrl()
    const [typeformLink] = useState(locale === 'fr' ? TYPEFORM_SCHEDULER_LINK_FR : TYPEFORM_SCHEDULER_LINK_NL)

    useEffect(() => {
        iframeRef.current.src = typeformLink
    }, [])

    return (
        <PageWrapper disableFooterLists>
            <StartupsHelmet />
            <Box className={classes.bannerContainer}>
                <Box className={classes.imageContainer}>
                    <Hidden smDown>
                        <Box className={classes.imageBox}>
                            <Image
                                cloudName='studentbe'
                                publicId='assets/startups-meeting'
                                alt='student.be startups meeting.'
                                className={classes.image}
                            >
                                <Transformation flags='progressive' fetchFormat='auto' quality='auto:best' crop='fill' />
                            </Image>
                        </Box>
                    </Hidden>
                    <Box className={classes.imageTextBox}>
                        <Typography variant='h1' className={classes.titlePage}>
                            <FormattedMessage id="startup_landing_page.hero_title" />
                        </Typography>
                        <Typography variant='h3' className={classes.subtitlePage}>
                            <FormattedMessage id="startup_landing_page.hero_subtitle" />
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Container maxWidth='md'>
                <Box className={classes.keyInfoContainer}>
                    <Box className={classes.keyInfoLeftSideContainer}>
                        <Box className={classes.keyInfoLeftSide}>
                            <Typography variant='h1' component='h2'>
                                <FormattedMessage id="startup_landing_page.section1_title" />
                            </Typography>
                            <Typography variant='body1' className={classes.fontSize16}>
                                <ul>
                                    <li><FormattedMessage id="startup_landing_page.section1_bullet1" /></li>
                                    <li><FormattedMessage id="startup_landing_page.section1_bullet2" /></li>
                                    <li><FormattedMessage id="startup_landing_page.section1_bullet3" /></li>
                                </ul>
                            </Typography>
                            <Typography variant='body1' className={classes.fontSize16}>
                                <FormattedMessage id="startup_landing_page.section1_followup" />
                            </Typography>
                            <Typography variant='h1' component='h2'>
                                <FormattedMessage id="startup_landing_page.section2_title" />
                            </Typography>
                            <Typography variant='body1' className={classes.fontSize16}>
                                <FormattedMessage id="startup_landing_page.section2_description" />
                            </Typography>
                            <Box className={classes.registrationButtonBox1}>
                                <Button
                                    className={classes.registrationButton}
                                    color='secondary'
                                    href={typeformLink}
                                    target='_blank'
                                >
                                    <FormattedMessage id="startup_landing_page.book_demo" />
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                    <Box className={classes.keyInfoRightSide}>
                        <Hidden smDown>
                            <Image
                                className={classes.introImage}
                                cloudName="studentbe"
                                publicId='assets/startups-students'
                                alt='busines school image'
                            >
                                <Transformation flags="progressive" fetchFormat="auto" width={MEDIUM_SIZE} quality="auto:best" crop="fill" />
                            </Image>
                        </Hidden>
                    </Box>
                </Box>
                <Box className={classes.mapContainer} my={5}>
                    <Box>
                        <Typography variant='h1' component='h2'>
                            <FormattedMessage id="startup_landing_page.section3_title" />
                        </Typography>
                        <Typography variant='body1' className={classes.fontSize16}>
                            <FormattedMessage id="startup_landing_page.section3_description" />
                        </Typography>
                    </Box>
                    <Box className={classes.mapBox}>
                        <Image
                            className={classes.mapImage}
                            cloudName="studentbe"
                            publicId='assets/schools-map'
                            alt='busines school image'
                        >
                            <Transformation flags="progressive" fetchFormat="auto" width={MEDIUM_SIZE} quality="auto:best" crop="fill" />
                        </Image>
                    </Box>
                </Box>
                <Box className={classes.extraInfoContainer} my={5}>
                    <Box>
                        <Typography variant='h1' component='h2'>
                            <FormattedMessage id="startup_landing_page.section4_title" />
                        </Typography>
                    </Box>
                    <Box my={2}>
                        <Typography variant='body1' className={classes.fontSize16}>
                            <FormattedMessage id="startup_landing_page.section4_description" />
                        </Typography>
                    </Box>
                    <Box my={2}>
                        <Typography variant='h1' component='h2'>
                            <FormattedMessage id="startup_landing_page.section5_title" />
                        </Typography>
                    </Box>
                    <Box my={2}>
                        <ul>
                            <li>
                                <Typography variant='body1' className={classes.fontSize16}>
                                    <span className={classes.spanBold}>
                                        <FormattedMessage id="startup_landing_page.benefit1_title" />
                                    </span>
                                    <FormattedMessage id="startup_landing_page.benefit1_text" />
                                </Typography>
                            </li>
                            <li>
                                <Typography variant='body1' className={classes.fontSize16}>
                                    <span className={classes.spanBold}>
                                        <FormattedMessage id="startup_landing_page.benefit2_title" />
                                    </span>
                                    <FormattedMessage id="startup_landing_page.benefit2_text" />
                                </Typography>
                            </li>
                            <li>
                                <Typography variant='body1' className={classes.fontSize16}>
                                    <span className={classes.spanBold}>
                                        <FormattedMessage id="startup_landing_page.benefit3_title" />
                                    </span>
                                    <FormattedMessage id="startup_landing_page.benefit3_text" />
                                </Typography>
                            </li>
                        </ul>
                    </Box>
                    <Box>
                        <Typography variant='h1' component='h2'>
                            <FormattedMessage id="startup_landing_page.section6_title" />
                        </Typography>
                    </Box>
                    <Box my={2}>
                        <FormattedMessage id="startup_landing_page.section6_description" >
                            {text =>
                                <Typography variant='body1' className={classes.fontSize16} dangerouslySetInnerHTML={{ __html: text }} />
                            }
                        </FormattedMessage>
                    </Box>
                    <Box className={classes.registrationButtonBox2}>
                        <Button
                            className={classes.registrationButton}
                            color='secondary'
                            href={typeformLink}
                            target='_blank'
                        >
                            <FormattedMessage id="startup_landing_page.book_demo" />
                        </Button>
                    </Box>
                </Box>
                <Box mt={4} mb={2}>
                    <Typography variant='h1' component='h2'>
                        <FormattedMessage id="startup_landing_page.section7_title" />
                    </Typography>
                </Box>
                <Box my={2}>
                    <Typography variant='body1' className={classes.fontSize16}>
                        <FormattedMessage id="startup_landing_page.section7_description" />
                    </Typography>
                </Box>
                <Container disableGutters maxWidth='lg' className={classes.sliderContainer}>
                    <HorizontalCardsSlider wrappedArrows shift={500}>
                        {startups.map((startup, index) => (
                            <Box key={`company-card-${index}`} className={classes.companyCardBox}>
                                <CompanyCard company={startup} />
                            </Box>
                        ))}
                    </HorizontalCardsSlider>
                </Container>
                <Box mt={4} mb={2}>
                    <Typography variant='h1' component='h2'>
                        <FormattedMessage id="startup_landing_page.final_cta_title" />
                    </Typography>
                </Box>
                <Box my={2}>
                    <Typography variant='body1' className={classes.fontSize16}>
                        <FormattedMessage id="startup_landing_page.final_cta_description" />
                    </Typography>
                </Box>
                <Box className={classes.pipedriveSchedule}>
                    <iframe
                        ref={iframeRef}
                        title="Pipedrive Scheduler Embed"
                        frameBorder="0"
                        className={classes.pipedriveScheduleFrame}
                        style={{ }}
                        allowFullScreen
                    ></iframe>
                </Box>
            </Container>
        </PageWrapper>
    )
}

export default StartupsLandingPage
